//back to this
import AdminTemplate from "../../templates/admin";

function Adminscreen() {
  return <AdminTemplate />;
}

export default Adminscreen;
